import Http from '@/api/http.js'

export default {
  show(id) {
    return Http.get(`/economic_groups/${id}`);
  }, 
  index(params){
    return Http.get(`/economic_groups`, { params });
  },
  create(economic_group){
    return Http.post(`/economic_groups`, {economic_group: {...economic_group}})
  },
  update(economic_group){
    return Http.put(`/economic_groups/${economic_group.id}`, {economic_group: {...economic_group}})
  },
}



